// components/finance/Header.jsx
// Finance Dashboard Header using StandardHeader - RESPONSIVE

import React from 'react';
import { StandardHeader } from '../../common/StandardHeader';
import { useCacheRefresh } from '../../../hooks/useCacheRefresh';

export const Header = ({ 
  loading, 
  lastUpdated, 
  dateRange, 
  onDateRangeChange,
  yearsOnly = true,
}) => {
  const { refreshFinanceCache, isRefreshingFinance } = useCacheRefresh();

  const handleRefresh = () => {
    const year = dateRange?.start_date 
      ? new Date(dateRange.start_date).getFullYear() 
      : new Date().getFullYear();
    
    refreshFinanceCache({ year });
  };

  return (
    <StandardHeader
      title="Finance Dashboard"
      subtitle="Comprehensive analytics for finance"
      loading={loading}
      lastUpdated={lastUpdated}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      onRefresh={handleRefresh}
      isRefreshing={isRefreshingFinance}
      yearsOnly={yearsOnly}
    />
  );
};